import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from '../../../../common/alert-service/alert.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {DeliveryCocMaterialService} from './delivery-coc-material.service';
import {DeliveryListData} from '../../models/delivery.models';

@Component({
    selector: 'delivery-coc-material-modal',
    templateUrl: './delivery-coc-material-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DeliveryCocMaterialModalComponent implements OnInit {
  @Input() delivery: DeliveryListData;
  @Input() materials: string[] = [];
  form: UntypedFormGroup;
  locked: boolean = false;

  constructor(private modalRef: NgbActiveModal,
              private alertService: AlertService,
              private deliveryCocMaterialService: DeliveryCocMaterialService,
              private fb: UntypedFormBuilder) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      material: [
        this.delivery.material === 'Standard FR4' ?
          null :
          this.delivery.material,
        Validators.required,
      ],
    });
  }

  dismiss(): void {
    this.modalRef.dismiss();
  }

  submit(): void {
    this.locked = true;
    this.deliveryCocMaterialService.save(this.delivery.id, this.form.value).subscribe({
      next: () => {
        this.locked = false;
        this.modalRef.close(this.form.value.material);
      },
      error: error => {
        console.error(error);
        this.locked = false;
        this.alertService.add('danger', 'Konnte Material nicht setzen');
      },
    });
  }

}
